import TokenAnalyzerAiStats from "./TokenAnalyzerAiStats";

export default TokenAnalyzerAiStats;